<template>
  <nav class="m-the-header-navigation">
    <ul>
      <li
        v-for="(navItem, index) in navigationItems"
        :key="index"
      >
        <a
          v-if="navItem.subMenu"
          class="m-the-header-navigation-access-submenu"
          href="/aside"
          :id="`subitem-${navItem.routeName}`"
          @click.prevent="$utils.switchAsideNavigationMenu()"
        >
          <i class="fas fa-bars"></i>
          <span>{{ $t('mTheHeaderNav.subMenu') }}</span>
        </a>
        <a
          :class="navItem.class"
          :disabled="!isLoading"
          href="#"
          @click.prevent="gotToSection(navItem.to)"
        >
          <i :class="navItem.icon"></i>
          <span>{{ navItem.text  }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderNavigation',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      headerNavigation: {},
      itemActive: '',

      itemClasses: {
        assets: 'm-the-header-navigation-item-assets',
        maps: 'm-the-header-navigation-item-maps',
        billing: 'm-the-header-navigation-item-billing'
      },

      navigationItems: [
        {
          brand: 'assets',
          class: '',
          edition: '',
          icon: 'fad fa-folder-open',
          routeName: 'assets',
          subMenu: false,
          text: '',
          to: ''
        },

        {
          brand: 'maps',
          class: '',
          edition: '',
          icon: 'fad fa-map-marker-alt',
          routeName: 'maps',
          subMenu: false,
          text: '',
          to: ''
        },

        {
          brand: 'billing',
          class: '',
          edition: '',
          icon: 'fad fa-credit-card',
          routeName: 'billing',
          subMenu: false,
          text: '',
          to: ''
        }
      ]
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  },

  watch: {
    $route (to, from) {
      this.setNavigationItemsClasses()
    }
  },

  created () {
    this.setNavigationItemsRoutes()
    this.setNavigationItemsClasses()
  },

  methods: {
    gotToSection (navItemTo) {
      if (!this.isLoading) {
        this.$router.push(navItemTo)
      }
    },

    setNavigationItemsClasses () {
      this.itemActive = this.$route.meta.isEdition === 'asset' ? `${this.$route.meta.isEdition}s` : this.$route.meta.isEdition

      this.navigationItems.forEach(navItem => {
        navItem.text = this.$t(`mTheHeaderNav.${navItem.brand}`)
        navItem.class = this.academyDataColor ? 'm-the-header-navigation-item-academy' : this.itemClasses[`${navItem.brand}`]
        navItem.class = navItem.routeName === this.itemActive ? `${navItem.class}-active` : navItem.class
        navItem.subMenu = navItem.routeName === this.itemActive && this.$route.meta.isEdition !== 'assets' && this.$route.meta.isEdition !== 'maps'
      })
    },

    setNavigationItemsRoutes () {
      this.navigationItems.forEach(navItem => {
        navItem.to = this.$router.options.routes.find(route => route.name === navItem.routeName).path
      })

      this.navigationItems[2].to = `${(this.navigationItems[2].to).replace('/:subject', '/')}${this.$t('mEditionMenu.billing.myShopping.subject')}`
    }
  }
}
</script>
